import React, { Component } from "react";
import {
  FieldGroup,
  FieldControl,
  FormBuilder,
  Validators
} from "react-reactive-form";
import PropTypes from "proptypes";
import { Auth, API } from "aws-amplify";
import { phoneNumberValidator, readableResponseMessage } from "ux-helpers";
import PortalHeader from "../../lib/portalHeader/PortalHeader";
import PastTrips from "./PastTrips";
import { Countries } from "./../../../helpers/CountriesAndNationalities";
import {
  UniversityUSA,
  UniversityUK,
  UniversityAustralia
} from "./../../../helpers/University";
import HelpfulLinks from "../../lib/helpfulLinks/HelpfulLinks";

export default class Profile extends Component {
  state = {};

  componentDidMount() {
    if (window.location.hash) {
      const scrollElement = document.getElementById(window.location.hash.substring(1));
      if (scrollElement && scrollElement.offsetTop) {
        window.scrollTo({
          top: scrollElement.offsetTop - 100,
          behavior: 'smooth'
        })
      }
    } else {
      window.scrollTo({
        top: 400,
        behavior: 'smooth',
      })
    }
  }

  compareEmails = control => {
    if (
      control.value &&
      control.value.toLowerCase() === this.props.user.email.toLowerCase()
    ) {
      return { email: true };
    } else {
      return null;
    }
  };

  getUniversity = val => {
    if (
      !UniversityUSA.includes(val) &&
      !UniversityUK.includes(val) &&
      !UniversityAustralia.includes(val)
    ) {
      return("Other");
    } else {
      return(val);
    }
  }

  profileForm = FormBuilder.group({
    firstName: [this.props.user.firstName, Validators.maxLength(50)],
    lastName: [this.props.user.lastName, Validators.maxLength(50)],

    mailingStreet: [this.props.user.mailingStreet, Validators.maxLength(100)],
    mailingCity: [this.props.user.mailingCity, Validators.maxLength(50)],
    mailingState: [this.props.user.mailingState],
    mailingCountry: [this.props.user.mailingCountry],
    mailingPostalCode: [this.props.user.mailingPostalCode],

    phoneNumber: [
      this.props.user.phone,
      [phoneNumberValidator, Validators.maxLength(50)]
    ],

    email: [
      this.props.user.email,
      [Validators.required, Validators.email, Validators.maxLength(50)]
    ],
    alternateEmail: [
      this.props.user.alternateEmail,
      [Validators.email, Validators.maxLength(50)]
    ],

    facebook: [this.props.user.facebook],
    instagram: [this.props.user.instagram],
    shirtSize: [this.props.user.shirtSize],

    allergies: [this.props.user.allergies],
    medications: [this.props.user.medications],
    medicalConditions: [this.props.user.medicalConditions],
    dietaryRequirements: [this.props.user.dietaryRequirements],
    medicalNotes: [this.props.user.medicalNotes],

    emergencyContact: [this.props.user.emergencyContact],
    eCEmail: [
      this.props.user.eCEmail,
      [
        Validators.required,
        Validators.email,
        Validators.maxLength(50),
        this.compareEmails
      ]
    ],
    eCPhone: [this.props.user.eCPhone, [phoneNumberValidator]],
    eCRelationship: [this.props.user.eCRelationship],

    university: [this.getUniversity(this.props.user.university)],
    universityOther: [(this.props.user.university !== 'Other') ? this.props.user.university : ''],
    graduated: [this.props.user.graduated.toString()],
    graduationYear: [this.props.user.graduationYear],

    emailOptOutFundraisingEmailList: [
      this.props.user.emailOptOutFundraisingEmailList.toString()
    ],
    emailOptOutNewsletterEmailList: [
      this.props.user.emailOptOutNewsletterEmailList.toString()
    ],
    emailOptOutPromotionsEmailList: [
      this.props.user.emailOptOutPromotionsEmailList.toString()
    ],
    emailOptOutUpdatesEmailList: [
      this.props.user.emailOptOutUpdatesEmailList.toString()
    ]
  });

  handleSubmit = e => {
    e.preventDefault();
    if (this.profileForm.status === "VALID") {
      this.setState({ loadingBtn: true });
      this.profileForm.handleSubmit();
      let profileData = this.profileForm.value;
      if (profileData.university === 'Other' && profileData.universityOther !== 'Other') {
        profileData.university = profileData.universityOther;
      }
      Auth.currentSession().then(user => {
        const options = {
          headers: {
            Authorization: user.idToken.jwtToken,
            Token: user.accessToken.jwtToken,
            "Content-Type": "application/json"
          },
          body: profileData
        };
        options.body.userId = this.props.user.id;
        options.body.userName = user.idToken.payload.nickname;

        API.post("give-api", "/user/", options)
          .then(response => {
            this.setState({
              user: {
                ...this.props.user,
                ...response.Data
              }
            });
            this.props.setAppState(this.state.user);
            this.setState({ loadingBtn: false, message: response.Message });
            this.profileForm.handleSubmit();
          })
          .catch(error => {
            this.setState({
              loadingBtn: false,
              message: readableResponseMessage(error)
            });
            this.profileForm.handleSubmit();
          });
      });
    } else {
      this.setState({ message: "Please fill in required fields" });
      this.profileForm.handleSubmit();
    }
  };

  render() {
    const country = Countries.map((count, i) => (
      <option key={count} value={Countries[i]}>
        {Countries[i]}
      </option>
    ));

    const universitiesUSA = UniversityUSA.map((count, i) => (
      <option key={count} value={UniversityUSA[i]}>
        {UniversityUSA[i]}
      </option>
    ));

    const universitiesUK = UniversityUK.map((count, i) => (
      <option key={count} value={UniversityUK[i]}>
        {UniversityUK[i]}
      </option>
    ));

    const universitiesAustralia = UniversityAustralia.map((count, i) => (
      <option key={count} value={UniversityAustralia[i]}>
        {UniversityAustralia[i]}
      </option>
    ));
    return (
      <div>
        <PortalHeader
          setAppState={this.props.setAppState}
          user={this.props.user}
          title="Traveler Information"
        />
        <div className="row">
          <div className="col-md-3">
            <div className="row helpfulLinksContainer chevrons-right-texture">
              <div className="col-md-12 styled-container margin-bottom-container">
                <HelpfulLinks />
              </div>
            </div>
          </div>
          <div className="col-md-9 responsive-col profile-form">
            <h3 className="h1-style muted form-sub-title margin-bottom-text">
              Personal Information
            </h3>
            <FieldGroup
              control={this.profileForm}
              render={({ value, submitted }) => (
                <div className="justify-content-center">
                  <form
                    id="profile-form"
                    name="profileForm"
                    onSubmit={e => this.handleSubmit(e, value)}
                    autoComplete="off"
                  >
                    <div className="col-md-6 col-sm-12 padding-right">
                      <FieldControl
                        name="firstName"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <input
                              className="form-control"
                              type="text"
                              {...handler()}
                            />
                            <label
                              htmlFor="firstName"
                              className={`label ${
                                pristine &&
                                !this.profileForm.controls.firstName.value
                                  ? ""
                                  : "notEmpty"
                              }`}
                            >
                              First Name
                              <span className="error">
                                {(touched || submitted) &&
                                  hasError("required") &&
                                  " - Required"}
                                {hasError("maxLength") &&
                                  " - Exceeds Max Character Limit "}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>

                    <div className="col-md-6 col-sm-12 padding-right">
                      <FieldControl
                        name="lastName"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <input
                              className="form-control"
                              type="text"
                              {...handler()}
                            />
                            <label
                              htmlFor="lastNmae"
                              className={`label ${
                                pristine &&
                                !this.profileForm.controls.lastName.value
                                  ? ""
                                  : "notEmpty"
                              }`}
                            >
                              Last Name
                              <span className="error">
                                {(touched || submitted) &&
                                  hasError("required") &&
                                  " - Required"}
                                {hasError("maxLength") &&
                                  " - Exceeds Max Character Limit "}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>

                    <div className="col-md-12 col-sm-12 padding-right">
                      <FieldControl
                        name="mailingStreet"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <input
                              className="form-control"
                              type="text"
                              {...handler()}
                            />
                            <label
                              htmlFor="mailingStreet"
                              className={`label ${
                                pristine &&
                                !this.profileForm.controls.mailingStreet.value
                                  ? ""
                                  : "notEmpty"
                              }`}
                            >
                              Street
                              <span className="error">
                                {(touched || submitted) &&
                                  hasError("required") &&
                                  " - Required"}
                                {hasError("maxLength") &&
                                  " - Exceeds Max Character Limit "}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>

                    <div className="col-md-4 col-sm-12 padding-right">
                      <FieldControl
                        name="mailingCity"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <input
                              className="form-control"
                              type="text"
                              {...handler()}
                            />
                            <label
                              htmlFor="city"
                              className={`label ${
                                pristine &&
                                !this.profileForm.controls.mailingCity.value
                                  ? ""
                                  : "notEmpty"
                              }`}
                            >
                              City
                              <span className="error">
                                {(touched || submitted) &&
                                  hasError("required") &&
                                  " - Required"}
                                {hasError("maxLength") &&
                                  " - Exceeds Max Character Limit "}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-4 col-sm-12 padding-right">
                      <FieldControl
                        name="mailingState"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <select
                              className="custom-arrow form-control"
                              {...handler()}
                            >
                              <option disabled value="">
                                {" "}
                                State / Province{" "}
                              </option>
                              <option value="Alabama">Alabama</option>
                              <option value="Alaska">Alaska</option>
                              <option value="Alberta">Alberta</option>
                              <option value="Arizona">Arizona</option>
                              <option value="Arkansas">Arkansas</option>
                              <option value="British Columbia">
                                British Columbia
                              </option>
                              <option value="California">California</option>
                              <option value="Colorado">Colorado</option>
                              <option value="Connecticut">Connecticut</option>
                              <option value="Delaware">Delaware</option>
                              <option value="District of Columbia">
                                District of Columbia
                              </option>
                              <option value="Florida">Florida</option>
                              <option value="Georgia">Georgia</option>
                              <option value="Hawaii">Hawaii</option>
                              <option value="Idaho">Idaho</option>
                              <option value="Illinois">Illinois</option>
                              <option value="Indiana">Indiana</option>
                              <option value="Iowa">Iowa</option>
                              <option value="Kansas">Kansas</option>
                              <option value="Kentucky">Kentucky</option>
                              <option value="Louisiana">Louisiana</option>
                              <option value="Maine">Maine</option>
                              <option value="Manitoba">Manitoba</option>
                              <option value="Maryland">Maryland</option>
                              <option value="Massachusetts">
                                Massachusetts
                              </option>
                              <option value="Michigan">Michigan</option>
                              <option value="Minnesota">Minnesota</option>
                              <option value="Mississippi">Mississippi</option>
                              <option value="Missouri">Missouri</option>
                              <option value="Montana">Montana</option>
                              <option value="Nebraska">Nebraska</option>
                              <option value="Nevada">Nevada</option>
                              <option value="New Brunswick">
                                New Brunswick
                              </option>
                              <option value="New Hampshire">
                                New Hampshire
                              </option>
                              <option value="New Jersey">New Jersey</option>
                              <option value="New Mexico">New Mexico</option>
                              <option value="New York">New York</option>
                              <option value="Newfoundland">Newfoundland</option>
                              <option value="North Carolina">
                                North Carolina
                              </option>
                              <option value="North Dakota">North Dakota</option>
                              <option value="Northwest Territories">
                                Northwest Territories
                              </option>
                              <option value="Nova Scotia">Nova Scotia</option>
                              <option value="Nunavut">Nunavut</option>
                              <option value="Ohio">Ohio</option>
                              <option value="Oklahoma">Oklahoma</option>
                              <option value="Ontario">Ontario</option>
                              <option value="Oregon">Oregon</option>
                              <option value="Pennsylvania">Pennsylvania</option>
                              <option value="Prince Edward Island">
                                Prince Edward Island
                              </option>
                              <option value="Quebec">Quebec</option>
                              <option value="Rhode Island">Rhode Island</option>
                              <option value="Saskatchewan">Saskatchewan</option>
                              <option value="South Carolina">
                                South Carolina
                              </option>
                              <option value="South Dakota">South Dakota</option>
                              <option value="Tennessee">Tennessee</option>
                              <option value="Texas">Texas</option>
                              <option value="Utah">Utah</option>
                              <option value="Vermont">Vermont</option>
                              <option value="Virginia">Virginia</option>
                              <option value="Washington">Washington</option>
                              <option value="West Virginia">
                                West Virginia
                              </option>
                              <option value="Wisconsin">Wisconsin</option>
                              <option value="Wyoming">Wyoming</option>
                              <option value="Yukon">Yukon</option>
                            </select>
                            <label
                              htmlFor="mailingState"
                              className={`label ${
                                pristine &&
                                !this.profileForm.controls.mailingState.value
                                  ? ""
                                  : "notEmpty"
                              }`}
                            >
                              State
                              <span className="error">
                                {(touched || submitted) &&
                                  hasError("required") &&
                                  " - Required"}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>

                    <div className="col-md-4 col-sm-12 padding-right">
                      <FieldControl
                        name="mailingPostalCode"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <input
                              className="form-control"
                              type="number"
                              {...handler()}
                            />
                            <label
                              htmlFor="mailingPostalCode"
                              className={`label ${
                                pristine &&
                                !this.profileForm.controls.mailingPostalCode
                                  .value
                                  ? ""
                                  : "notEmpty"
                              }`}
                            >
                              Zip Code
                              <span className="error">
                                {(touched || submitted) &&
                                  hasError("required") &&
                                  " - Required"}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>

                    <div className="col-md-6 col-sm-12 padding-right">
                      <FieldControl
                        name="mailingCountry"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <select
                              name="mailingCountry"
                              className="custom-arrow form-control"
                              placeholder="booleanStudentTrue"
                              {...handler()}
                            >
                              <optgroup>
                                <option disabled value="">
                                  {" "}
                                  Country{" "}
                                </option>
                                <option value="United States">
                                  United States
                                </option>
                                <option value="United Kingdom">
                                  United Kingdom
                                </option>
                                <option value="Australia">Australia</option>
                                <option value="Canada">Canada</option>
                              </optgroup>
                              <optgroup>{country}</optgroup>
                            </select>
                            <label
                              htmlFor="mailingCountry"
                              className={`label ${
                                pristine &&
                                !this.profileForm.controls.mailingCountry.value
                                  ? ""
                                  : "notEmpty"
                              }`}
                            >
                              Country
                              <span className="error">
                                {(touched || submitted) &&
                                  hasError("required") &&
                                  " - Required"}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>

                    <div className="col-md-6 col-sm-12 padding-right">
                      <FieldControl
                        name="phoneNumber"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <input
                              className="form-control"
                              type="tel"
                              {...handler()}
                            />
                            <label
                              htmlFor="phoneNumber"
                              className={`label ${
                                pristine &&
                                !this.profileForm.controls.phoneNumber.value
                                  ? ""
                                  : "notEmpty"
                              }`}
                            >
                              Moble Phone Number
                              <span className="error">
                                {((touched || submitted) &&
                                  hasError("required") &&
                                  " - Required") ||
                                  ((touched || submitted) &&
                                    hasError("phoneNumber") && (
                                      <span className="bubble-error-message">
                                        Format: XXX-XXX-XXXX, International
                                        X-XXX-XXX-XXXX
                                      </span>
                                    ))}
                                {hasError("maxLength") &&
                                  " - Exceeds Max Character Limit "}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>

                    <div className="col-md-6 col-sm-12 padding-right">
                      <FieldControl
                        name="email"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <input
                              className="form-control"
                              type="email"
                              {...handler()}
                              disabled
                            />
                            <label
                              htmlFor="email"
                              className={`label ${
                                pristine &&
                                !this.profileForm.controls.email.value
                                  ? ""
                                  : "notEmpty"
                              }`}
                            >
                              Email Address
                              <span className="error">
                                {(touched || submitted) &&
                                  hasError("required") &&
                                  " - Required"}
                                {hasError("maxLength") &&
                                  " - Exceeds Max Character Limit "}
                                {hasError("email") &&
                                  " - Please include @ with email address "}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-6 col-sm-12 padding-right">
                      <FieldControl
                        name="alternateEmail"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <input
                              className="form-control"
                              type="email"
                              {...handler()}
                            />
                            <label
                              htmlFor="alternateEmail"
                              className={`label ${
                                pristine &&
                                !this.profileForm.controls.alternateEmail.value
                                  ? ""
                                  : "notEmpty"
                              }`}
                            >
                              Alternate Email
                              <span className="error">
                                {(touched || submitted) &&
                                  hasError("required") &&
                                  " - Required"}
                                {hasError("maxLength") &&
                                  " - Exceeds Max Character Limit "}
                                {hasError("email") &&
                                  " - Please include @ with email address "}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>

                    <div className="col-md-5 col-sm-12 padding-right">
                      <FieldControl
                        name="instagram"
                        render={({ handler, pristine }) => (
                          <div className="inputContainer">
                            <input
                              className="form-control"
                              type="text"
                              {...handler()}
                            />
                            <label
                              htmlFor="instagram"
                              className={`label label-fix ${
                                pristine &&
                                !this.profileForm.controls.instagram.value
                                  ? ""
                                  : "notEmpty"
                              }`}
                            >
                              Instagram Handle
                            </label>
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-5 col-sm-12 padding-right">
                      <FieldControl
                        name="facebook"
                        render={({ handler, pristine }) => (
                          <div className="inputContainer">
                            <input
                              className="form-control"
                              type="text"
                              {...handler()}
                            />
                            <label
                              htmlFor="facebookHandle"
                              className={`label label-fix ${
                                pristine &&
                                !this.profileForm.controls.facebook.value
                                  ? ""
                                  : "notEmpty"
                              }`}
                            >
                              Facebook Handle
                            </label>
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-2 col-sm-12 padding-right">
                      <FieldControl
                        name="shirtSize"
                        render={({ handler, pristine }) => (
                          <div className="inputContainer">
                            <select
                              className="custom-arrow form-control"
                              type="text"
                              {...handler()}
                            >
                              <option value="none">None</option>
                              <option value="XS">XS</option>
                              <option value="S">S</option>
                              <option value="M">M</option>
                              <option value="L">L</option>
                              <option value="XL">XL</option>
                              <option value="XXL">XXL</option>
                              <option value="XXXL">XXXL</option>
                            </select>
                            <label
                              htmlFor="shirtSize"
                              className={`label ${
                                pristine &&
                                !this.profileForm.controls.shirtSize.value
                                  ? ""
                                  : "notEmpty"
                              }`}
                            >
                              Shirt Size
                            </label>
                          </div>
                        )}
                      />
                    </div>

                    <h3 className="col-md-12 form-sub-title">
                      Medical Information
                    </h3>
                    <div className="col-md-6 col-sm-12 padding-right">
                      <FieldControl
                        name="medicalNotes"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <textarea
                              className="form-control"
                              type="text"
                              {...handler()}
                            />
                            <label
                              htmlFor="medicalNotes"
                              className={`label ${
                                pristine &&
                                !this.profileForm.controls.medicalNotes.value
                                  ? ""
                                  : "notEmpty"
                              }`}
                            >
                              Medical Notes
                              <span className="error">
                                {(touched || submitted) &&
                                  hasError("required") &&
                                  " - Required"}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                      <FieldControl
                        name="allergies"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <textarea
                              className="form-control"
                              type="text"
                              {...handler()}
                            />
                            <label
                              htmlFor="allergies"
                              className={`label ${
                                pristine &&
                                !this.profileForm.controls.allergies.value
                                  ? ""
                                  : "notEmpty"
                              }`}
                            >
                              Allergies
                              <span className="error">
                                {(touched || submitted) &&
                                  hasError("required") &&
                                  " - Required"}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>

                    <div className="col-md-6 col-sm-12 padding-right">
                      <FieldControl
                        name="medications"
                        render={({ handler, pristine }) => (
                          <div className="inputContainer">
                            <textarea
                              className="form-control"
                              type="text"
                              {...handler()}
                            />
                            <label
                              htmlFor="medications"
                              className={`label ${
                                pristine &&
                                !this.profileForm.controls.medications.value
                                  ? ""
                                  : "notEmpty"
                              }`}
                            >
                              Medications
                              <span className="error" />
                            </label>
                          </div>
                        )}
                      />
                      <FieldControl
                        name="dietaryRequirements"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <textarea
                              className="form-control"
                              type="text"
                              {...handler()}
                            />
                            <label
                              htmlFor="dietaryRequirements"
                              className={`label ${
                                pristine &&
                                !this.profileForm.controls.dietaryRequirements
                                  .value
                                  ? ""
                                  : "notEmpty"
                              }`}
                            >
                              Dietary Requirements
                              <span className="error">
                                {(touched || submitted) &&
                                  hasError("required") &&
                                  " - Required"}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>

                    <div className="col-md-12 col-sm-12 padding-right">
                      <FieldControl
                        name="medicalConditions"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <textarea
                              className="form-control"
                              type="text"
                              {...handler()}
                            />
                            <label
                              htmlFor="medicalConditions"
                              className={`label ${
                                pristine &&
                                !this.profileForm.controls.medicalConditions
                                  .value
                                  ? ""
                                  : "notEmpty"
                              }`}
                            >
                              Medical Conditions
                              <span className="error">
                                {(touched || submitted) &&
                                  hasError("required") &&
                                  " - Required"}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>

                    <h3 className="col-md-12 form-sub-title">
                      Emergency Contact
                    </h3>
                    <div className="col-md-6 col-sm-12 padding-right">
                      <FieldControl
                        name="emergencyContact"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <input
                              className="form-control"
                              type="text"
                              {...handler()}
                            />
                            <label
                              htmlFor="emergencyContact"
                              className={`label ${
                                pristine &&
                                !this.profileForm.controls.emergencyContact
                                  .value
                                  ? ""
                                  : "notEmpty"
                              }`}
                            >
                              Emergency Contact
                              <span className="error">
                                {(touched || submitted) &&
                                  hasError("required") &&
                                  " - Required"}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-6 col-sm-12 padding-right">
                      <FieldControl
                        name="eCRelationship"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <input
                              className="form-control"
                              type="text"
                              {...handler()}
                            />
                            <label
                              htmlFor="eCRelationship"
                              className={`label ${
                                pristine &&
                                !this.profileForm.controls.eCRelationship.value
                                  ? ""
                                  : "notEmpty"
                              }`}
                            >
                              Emergency Contact Relationship
                              <span className="error">
                                {(touched || submitted) &&
                                  hasError("required") &&
                                  " - Required"}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>

                    <div className="col-md-6 col-sm-12 padding-right">
                      <FieldControl
                        name="eCPhone"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <input
                              className="form-control"
                              type="number"
                              {...handler()}
                            />
                            <label
                              htmlFor="eCPhone"
                              className={`label ${
                                pristine &&
                                !this.profileForm.controls.eCPhone.value
                                  ? ""
                                  : "notEmpty"
                              }`}
                            >
                              Emergency Contact Phone Number
                              <span className="error">
                                {((touched || submitted) &&
                                  hasError("required") &&
                                  " - Required") ||
                                  (touched &&
                                    hasError("phoneNumber") && (
                                      <span className="bubble-error-message">
                                        Format: XXX-XXX-XXXX, International
                                        X-XXX-XXX-XXXX
                                      </span>
                                    ))}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-6 col-sm-12 padding-right">
                      <FieldControl
                        name="eCEmail"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <input
                              className="form-control"
                              type="email"
                              {...handler()}
                            />
                            <label
                              htmlFor="eCEmail"
                              className={`label ${
                                pristine &&
                                !this.profileForm.controls.eCEmail.value
                                  ? ""
                                  : "notEmpty"
                              }`}
                            >
                              Emergency Contact Email
                              <span className="error">
                                {(touched || submitted) &&
                                  hasError("required") &&
                                  " - Required"}
                                {hasError("maxLength") &&
                                  " - Exceeds Max Character Limit "}
                                {hasError("email") &&
                                  " - Please include @ with email address "}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>
                    <h3 className="col-md-12 form-sub-title">
                      School Information
                    </h3>

                    <div className="col-md-12 col-sm-12 padding-right">
                      {this.props.user.mailingCountry === "United States" ? (
                        <div>
                          <FieldControl
                            name="university"
                            render={({ handler, pristine }) => (
                              <div className="inputContainer">
                                <select
                                  id="university"
                                  className="custom-arrow form-control"
                                  {...handler()}
                                >
                                  <option />
                                  {universitiesUSA}
                                </select>
                                <label
                                  htmlFor="university"
                                  className={`label ${
                                    pristine ? "" : "notEmpty"
                                  }`}
                                >
                                  USA University
                                </label>
                              </div>
                            )}
                          />
                        </div>
                      ) : null}

                      {this.props.user.mailingCountry === "United Kingdom" ? (
                        <div>
                          <FieldControl
                            name="university"
                            render={({ handler, pristine }) => (
                              <div className="inputContainer">
                                <select
                                  id="university"
                                  className="custom-arrow form-control"
                                  {...handler()}
                                  disabled
                                >
                                  <option />
                                  {universitiesUK}
                                </select>
                                <label
                                  htmlFor="university"
                                  className={`label ${
                                    pristine ? "" : "notEmpty"
                                  }`}
                                >
                                  UK University
                                </label>
                              </div>
                            )}
                          />
                        </div>
                      ) : null}
                      {this.props.user.mailingCountry === "Australia" ? (
                        <div>
                          <FieldControl
                            name="university"
                            render={({ handler, pristine }) => (
                              <div className="inputContainer">
                                <select
                                  id="university"
                                  className="custom-arrow form-control"
                                  {...handler()}
                                  disabled
                                >
                                  <option />
                                  {universitiesAustralia}
                                </select>
                                <label
                                  htmlFor="university"
                                  className={`label ${
                                    pristine ? "" : "notEmpty"
                                  }`}
                                >
                                  Australia University
                                </label>
                              </div>
                            )}
                          />
                        </div>
                      ) : null}
                      {this.profileForm.controls.university.value === "Other" ? (
                        <div>
                          <FieldControl
                            name="universityOther"
                            render={({ handler, touched, hasError, pristine }) => (
                              <div className="inputContainer">
                                <input
                                  className="form-control"
                                  type="text"
                                  {...handler()}
                                />
                                <label
                                  htmlFor="universityOther"
                                  className={`label ${pristine && !this.profileForm.controls.universityOther.value ? "" : "notEmpty"}`}
                                >
                                  University Name
                                  <span className="error">
                                    {(touched || submitted) &&
                                      hasError("required") &&
                                      " - Required"}
                                  </span>
                                </label>
                              </div>
                            )}
                          />
                        </div>
                      ) : null}
                    </div>

                    <div className="col-md-6 col-sm-12 center padding-right">
                      <FieldControl
                        name="graduated"
                        render={({ handler }) => (
                          <div className="inputContainer">
                            <div className="form-control">
                              <label htmlFor="graduated" className="label">
                                Have you graduated?
                              </label>

                              <label htmlFor="graduated">
                                <input
                                  className="radio-button"
                                  name="graduated"
                                  type="radio"
                                  {...handler("radio", "true")}
                                />
                                Yes
                              </label>
                              <label htmlFor="graduated">
                                <input
                                  className="radio-button"
                                  name="graduated"
                                  type="radio"
                                  {...handler("radio", "false")}
                                />
                                No
                              </label>
                            </div>
                          </div>
                        )}
                      />
                    </div>

                    <div className="col-md-6 col-sm-12 center padding-right">
                      <FieldControl
                        name="graduationYear"
                        render={({ handler, pristine }) => (
                          <div className="inputContainer">
                            <input
                              className="form-control"
                              type="number"
                              {...handler()}
                            />
                            <label
                              htmlFor="graduationYear"
                              className={`label ${
                                pristine &&
                                !this.profileForm.controls.graduationYear.value
                                  ? ""
                                  : "notEmpty"
                              }`}
                            >
                              Graduation Year
                            </label>
                          </div>
                        )}
                      />
                    </div>

                    {/* <h3 className="col-md-12 form-sub-title">Email List</h3> */}
                    <div className="row center">
                      {/* <div className="col-md-6 col-sm-12 padding-right ">
                        <FieldControl
                          name="emailOptOutUpdatesEmailList"
                          render={({ handler }) => (
                            <div className="form-control">
                              <label
                                htmlFor="emailOptOutUpdatesEmailList"
                                className="label"
                              >
                                GIVE Updates
                              </label>
                              <label htmlFor="emailOptOutUpdatesEmailList">
                                <input
                                  className="radio-button"
                                  name="emailOptOutUpdatesEmailList"
                                  type="radio"
                                  {...handler("radio", "false")}
                                />
                                Yes
                              </label>
                              <label htmlFor="emailOptOutUpdatesEmailList">
                                <input
                                  className="radio-button"
                                  name="emailOptOutUpdatesEmailList"
                                  type="radio"
                                  {...handler("radio", "true")}
                                />
                                No
                              </label>
                            </div>
                          )}
                        />
                      </div>
                      <div className="col-md-6 col-sm-12 padding-right ">
                        <FieldControl
                          name="emailOptOutFundraisingEmailList"
                          render={({ handler }) => (
                            <div className="form-control">
                              <label
                                htmlFor="emailOptOutFundraisingEmailList"
                                className="label"
                              >
                                Fundraising Information
                              </label>
                              <label htmlFor="emailOptOutFundraisingEmailList">
                                <input
                                  className="radio-button"
                                  name="emailOptOutFundraisingEmailList"
                                  type="radio"
                                  {...handler("radio", "false")}
                                />
                                Yes
                              </label>
                              <label htmlFor="emailOptOutFundraisingEmailList">
                                <input
                                  className="radio-button"
                                  name="emailOptOutFundraisingEmailList"
                                  type="radio"
                                  {...handler("radio", "true")}
                                />
                                No
                              </label>
                            </div>
                          )}
                        />
                      </div>

                      <div className="col-md-6 col-sm-12 padding-right ">
                        <FieldControl
                          name="emailOptOutNewsletterEmailList"
                          render={({ handler }) => (
                            <div className="form-control">
                              <label
                                htmlFor="emailOptOutNewsletterEmailList"
                                className="label"
                              >
                                GIVE Newsetter
                              </label>
                              <label htmlFor="emailOptOutNewsletterEmailList">
                                <input
                                  className="radio-button"
                                  name="emailOptOutNewsletterEmailList"
                                  type="radio"
                                  {...handler("radio", "false")}
                                />
                                Yes
                              </label>
                              <label htmlFor="emailOptOutNewsletterEmailList">
                                <input
                                  className="radio-button"
                                  name="emailOptOutNewsletterEmailList"
                                  type="radio"
                                  {...handler("radio", "true")}
                                />
                                No
                              </label>
                            </div>
                          )}
                        />
                      </div>

                      <div className="col-md-6 col-sm-12 padding-right ">
                        <FieldControl
                          name="emailOptOutPromotionsEmailList"
                          render={({ handler }) => (
                            <div className="form-control">
                              <label
                                htmlFor="emailOptOutPromotionsEmailList"
                                className="label"
                              >
                                GIVE Promotions
                              </label>
                              <label htmlFor="emailOptOutPromotionsEmailList">
                                <input
                                  className="radio-button"
                                  name="emailOptOutPromotionsEmailList"
                                  type="radio"
                                  {...handler("radio", "false")}
                                />
                                Yes
                              </label>
                              <label htmlFor="emailOptOutPromotionsEmailList">
                                <input
                                  className="radio-button"
                                  name="emailOptOutPromotionsEmailList"
                                  type="radio"
                                  {...handler("radio", "true")}
                                />
                                No
                              </label>
                            </div>
                          )}
                        />
                      </div> */}
                    </div>
                    <p
                      className={`center ${
                        this.state.message ===
                        "Your profile was successfully updated."
                          ? "success"
                          : "error"
                      }`}
                    >
                      {this.state.message}
                    </p>
                    <button
                      className={`margin-center ${
                        this.state.loadingBtn ? "btn-text-hide" : ""
                      }`}
                      type="submit"
                      disabled={this.state.loadingBtn}
                    >
                      Update Profile
                      <span
                        className={`${
                          this.state.loadingBtn ? "loader loader-center" : ""
                        }`}
                      />
                    </button>
                  </form>
                </div>
              )}
            />
            <PastTrips pastTrips={this.props.user.pastTrips} />
          </div>
        </div>
      </div>
    );
  }
}

Profile.propTypes = {
  setAppState: PropTypes.func
};
Profile.defaultProps = {
  setAppState: () => {}
};
